import { State } from '../../../types/state';

export const showNetworkAlertSelector = (state: State) =>
  state.ui.showNetworkAlert;

export const complexLineItemsEnabledSelector = (state: State) =>
  state.user.uiSettings.complexLineItems ?? true;

export const automaticSuggestionsEnabledSelector = (state: State) =>
  state.user.uiSettings.automaticSuggestions ?? true;

export const auroraTourCompletedSelector = (state: State) => {
  return state.user.uiSettings.auroraTourCompleted;
};

export const readOnlySelector = (state: State): boolean => state.ui.readOnly;
